import { FlagStore } from "../flux/Flag/FlagStore";
import { ErrorStore } from "../flux/Error/ErrorStore";

type InProgressConfiguration = [FlagStore, (store: FlagStore) => ({ inProgress: boolean })];
export const inProgressConfig = (store: FlagStore) => [store, (store: FlagStore) => ({ inProgress: store.isSet() })];

type OkDisabledConfigureation = [FlagStore, (store: FlagStore) => ({ okDisabled: boolean })];
export function okDisabled (store: FlagStore): OkDisabledConfigureation
{
    return [store, (store: FlagStore)  => ({ okDisabled: store.isSet() })];
} 

type TwoButtonDialogConfigureation = [ErrorStore, [ FlagStore, (store: FlagStore) => ({ okDisabled: boolean }) ]];
export function twoButtonDialogConfig (flagStore: FlagStore, errorStore: ErrorStore): TwoButtonDialogConfigureation
{
    return [errorStore, okDisabled(flagStore)];
}


// WEBPACK FOOTER //
// ./src/app/utils/configure-store.ts